import cloneDeep from 'lodash/cloneDeep';
import { mapState } from 'vuex';
export default {
  name: 'DashboardParametersDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isSaving: false,
      editedParameters: {}
    };
  },
  computed: {
    ...mapState('dashboards', ['dashboards']),
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    dashboard() {
      return this.dashboards.find(dashboard => dashboard.id === this.dashboardId);
    },
    customParameters() {
      if (!this.dashboard) {
        return {};
      }
      return this.dashboard.value.customParameters || {};
    }
  },
  watch: {
    customParameters: {
      handler(newVal) {
        this.editedParameters = cloneDeep(newVal);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async save() {
      try {
        this.isSaving = true;
        await this.$store.dispatch('dashboards/changeDashboardConfig', {
          dashboardId: this.dashboardId,
          customParameters: this.editedParameters
        });
        this.$snack(this.$t('Dashboards.components.dashboardParametersDialog.snack.success.parametersSaved'), 'success');
        this.show = false;
      } catch (e) {
        this.$snack(this.$t('Dashboards.components.dashboardParametersDialog.snack.error.couldNotUpdateParameters', {
          error: e.message
        }), 'error');
        console.error(e);
      } finally {
        this.isSaving = false;
      }
    },
    removeParameter(key) {
      const clone = cloneDeep(this.editedParameters);
      delete clone[key];
      this.editedParameters = clone;
    },
    addEmptyParameter() {
      const clone = cloneDeep(this.editedParameters);
      clone[''] = '';
      this.editedParameters = clone;
    },
    updateParameterKey(key, newKey) {
      const clone = cloneDeep(this.editedParameters);
      clone[newKey] = clone[key];
      delete clone[key];
      this.editedParameters = clone;
    },
    updateParameterDefaultValue(key, value) {
      const clone = cloneDeep(this.editedParameters);
      clone[key] = value;
      this.editedParameters = clone;
    }
  }
};